export class Notifier {
  private subscribers: Subscriber[] = [];

  addSubscriber(sub: Subscriber) {
    this.subscribers.push(sub);
  }
  
  protected publish() {
    this.subscribers.forEach((sub) => {
      sub.notify();
    });
  }
}

export class Subscriber {
  public name: string;
  public callback: Function;

  public notify() {
    this.callback();
  };

  constructor(name: string, callback: Function) {
    this.name = name;
    this.callback = callback;
  }
}


// WEBPACK FOOTER //
// ./src/services/util/PubSub.ts